function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M501.512504,389.49667 L501.50333,389.487496 C500.175547,388.159714 498.022786,388.159714 496.695004,389.487496 L480,406.1825 L463.304996,389.487496 C461.977214,388.159714 459.824453,388.159714 458.49667,389.487496 L458.487496,389.49667 C457.159714,390.824453 457.159714,392.977214 458.487496,394.304996 L475.1825,411 L458.487496,427.695004 C457.159714,429.022786 457.159714,431.175547 458.487496,432.50333 L458.49667,432.512504 C459.824453,433.840286 461.977214,433.840286 463.304996,432.512504 L480,415.8175 L496.695004,432.512504 C498.022786,433.840286 500.175547,433.840286 501.50333,432.512504 L501.512504,432.50333 C502.840286,431.175547 502.840286,429.022786 501.512504,427.695004 L484.8175,411 L501.512504,394.304996 C502.840286,392.977214 502.840286,390.824453 501.512504,389.49667 Z",
  id: "path-1"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home-",
  transform: "translate(-449.000000, -380.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  transform: "translate(480.000000, 411.000000) rotate(45.000000) translate(-480.000000, -411.000000) ",
  xlinkHref: "#path-1"
})));

var SvgPlusWhite = function SvgPlusWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlusWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus_white.4375b1a5.svg";
export { ForwardRef as ReactComponent };